// Modelo de los datos de un cliente asociado a una reserva
export default class Client {
    constructor (
        public id: string = '',
        public nameSurname: string = '',
    ) {

    }
}
